import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=eea9ccd2&scoped=true&"
import script from "./NotificationTable.vue?vue&type=script&lang=js&"
export * from "./NotificationTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=eea9ccd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea9ccd2",
  null
  
)

export default component.exports